import type { LibraryItemStatus, LibrarySourceType } from "./types";

export const libraryCopy = {
  pageTitle: "My Library",
  pageDescription: "Save structured book records, preserve original scripts, and reuse them across your excerpts.",
  searchLabel: "Search books",
  searchPlaceholder: "Search by title, author, or ISBN…",
  saveAction: "Save to My Library",
  manualAction: "Add manually",
  editorTitle: "Book details",
  emptyTitle: "No saved books yet",
  emptyDescription: "Search for a book above or add one manually to start building your library.",
  sourceLabel: "Book / Source",
} as const;

export const librarySourceTypeOptions: Array<{ value: LibrarySourceType; label: string }> = [
  { value: "book", label: "Book" },
  { value: "journal_article", label: "Journal article" },
  { value: "chapter", label: "Book chapter" },
  { value: "proceedings_article", label: "Conference paper" },
  { value: "website", label: "Website" },
  { value: "report", label: "Report" },
  { value: "podcast", label: "Podcast episode" },
  { value: "other", label: "Other" },
];

export const getLibrarySourceTypeLabel = (value: LibrarySourceType) =>
  librarySourceTypeOptions.find((option) => option.value === value)?.label ?? "Source";

export const libraryItemStatusOptions: Array<{ value: LibraryItemStatus; label: string }> = [
  { value: "to_read", label: "To read" },
  { value: "reading", label: "Reading" },
  { value: "read", label: "Read" },
  { value: "revisit", label: "Revisit" },
];

export const getLibraryItemStatusLabel = (status: LibraryItemStatus) =>
  libraryItemStatusOptions.find((option) => option.value === status)?.label ?? "To read";

export const getLibraryProviderLabel = (provider: string | null | undefined) => {
  const normalized = provider?.trim().toLowerCase();
  if (!normalized || normalized === "manual") return "Manual";
  if (normalized === "google_books") return "Google Books";
  if (normalized === "open_library") return "Open Library";
  if (normalized === "isbndb") return "ISBNdb";
  if (normalized === "crossref") return "Crossref";
  if (normalized === "openalex") return "OpenAlex";
  return normalized
    .split(/[_\\s-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
};

export const getLibraryItemStatusSortWeight = (status: LibraryItemStatus) => ({
  reading: 0,
  to_read: 1,
  revisit: 2,
  read: 3,
}[status]);
